<template>
    <div class="Background">
        <div style="display: flex; justify-content: space-between;">
            <div class="link_location">
                <h2 class="Title">
                    {{ $store.getters.t('라이브') }}
                    <v-icon class="mdi mdi-chevron-right" />
                    <span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t('HLS 라이브') }}</span>
                  </h2>
            </div>
            <!-- <h2 class="Title">
            라이브 관리
            </h2> -->

            <!-- <div class="link_location">
                라이브 <v-icon small class="mdi mdi-chevron-right" />
                <a href="/wowzastream/wowzalivestream_create">라이브 관리</a>
            </div> -->
        </div>

            <WowzaLivestreamCreateForm />
    </div>
    
</template>
    
<script>
import WowzaLivestreamCreateForm from '@/components/livestream/WowzaLivestreamCreateForm.vue';

export default {
    components: {
        WowzaLivestreamCreateForm,
    },
}
</script>

<style lang="scss" scoped></style>